/*
 * @Descripttion: 
 * @Author: zhaozheng
 * @Version: 0.0.1
 * @Date: 2025-11-17 10:21:31
 * @LastEditors: zhaozheng
 * @LastEditTime: 2025-11-21 17:06:21
 */
import React, { VFC } from 'react';
import { css } from '@emotion/css';
import { useBgControl } from '../BgControlContext';

export const P7Section: VFC = () => {
  const bgControl = useBgControl();

  const handleOpenModal = () => {
    bgControl?.setModalOpen(true);
  };

  return (
    <>
      <section className={styles.wrapper} aria-label="P7">
        <h2 className={styles.title}>准备好开启您的"智能"时代了吗？</h2>
        <p className={styles.desc}>联系 AI 架构专家，获取一对一的免费咨询。</p>
        <div className={styles.ctaRow}>
          <button className={styles.ctaBtn} onClick={handleOpenModal}>
            预约免费咨询
          </button>
        </div>
      </section>
    </>
  );
};

const styles = {
  wrapper: css`
    pointer-events: none;
    position: relative;
    min-height: calc(var(--vh, 1vh) * 100);
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 6vh 0;
    width: min(1400px, 92vw);
    color: #fff;
    text-align: center;
  `,
  title: css`
    pointer-events: auto;
    font-size: 42px;
    font-weight: 800;
    margin: 0 0 5px 0;
    opacity: 0;
    transform: translate3d(30px, 0, 0);
    transition: opacity 0.7s ease, transform 0.7s ease;
    .reveal-visible & {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
    
    @media (max-width: 768px) {
      font-size: 32px;
    }
  `,
  desc: css`
    pointer-events: auto;
    margin: 0 auto 60px;
    opacity: 0;
    font-size: 20px;
    max-width: 760px;
    transform: translate3d(-30px, 0, 0);
    transition: opacity 0.7s ease, transform 0.7s ease;
    .reveal-visible & {
      opacity: 0.9;
      transform: translate3d(0, 0, 0);
    }
  `,
  ctaRow: css`
    pointer-events: auto;
    display: flex;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.7s ease 0.1s;

    .reveal-visible & {
      opacity: 1;
    }
  `,
  ctaBtn: css`
    appearance: none;
    border: 1px solid rgba(255, 255, 255, 0.8);
    background: transparent;
    color: #fff;
    padding: 10px 26px;
    border-radius: 999px;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s ease;
    outline: none;
    -webkit-tap-highlight-color: transparent;
    &:hover {
      background: rgba(255, 255, 255, 0.12);
      border-color: #fff;
      transform: translateY(-1px);
    }
  `,
};
